import { Box, Hidden, Theme, Typography } from '@mui/material'
import React from 'react'
import { checkImageExists } from '../utils/utilityFunctions'

export default function SchemeCard({
    schemeName,
    amcId
}: {
    schemeName: string;
    amcId: string;
}): JSX.Element {

    const amcIds = ['BDOTR', 'BPIAMC']
    const checkAmcId = amcIds.includes(amcId ?? '') ? amcId?.toLowerCase() : amcId;
    return (
        <>
            <Hidden lgUp>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "15px",
                        maxWidth: "100%",
                        width: "100%",
                    }}
                >
                    <Box
                        component="img"
                        src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                        sx={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '8px',
                            objectFit: "contain"
                        }}
                        alt={schemeName}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minWidth: 0,
                            rowGap: "7px"
                        }}
                    >
                        <Typography
                            variant="body_600"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                lineHeight: "22.5px",
                                letterSpacing: "0.02px"
                            })}
                            title={schemeName}
                        >
                            {schemeName}
                        </Typography>

                    </Box>
                </Box>
            </Hidden>
            <Hidden lgDown>
                <Box
                    sx={{
                        display: "flex",
                        columnGap: "10px",
                        alignItems: 'center'
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            columnGap: "15px",
                        }}
                    >
                        <Box
                            component="img"
                            src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                            sx={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '8px',
                                objectFit: "contain"
                            }}
                            alt={schemeName}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px"
                        }}
                    >

                        <Box sx={{ display: "flex", columnGap: "5px" }}>
                            <Typography
                                variant="body_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    lineHeight: "22.5px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeName}
                            >
                                {schemeName}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Hidden>
        </>
    )
}
